import axios, {
	AxiosError,
	AxiosInstance,
	AxiosRequestConfig,
	AxiosResponse,
} from 'axios';
// import cookie from 'js-cookie';

export interface AxiosApiInstance extends AxiosInstance {
	request<T = unknown>(config: AxiosRequestConfig): Promise<T>;
	get<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T>;
	delete<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T>;
	head<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T>;
	post<T = unknown>(
		url: string,
		data?: any,
		config?: AxiosRequestConfig
	): Promise<T>;
	put<T = unknown>(
		url: string,
		data?: any,
		config?: AxiosRequestConfig
	): Promise<T>;
	patch<T = unknown>(
		url: string,
		data?: any,
		config?: AxiosRequestConfig
	): Promise<T>;
}

export const apiInstance: AxiosApiInstance = axios.create({
	baseURL: '/',
});

apiInstance.interceptors.request.use(async (config) => {
	// const token = cookie.get('token') || '';
	// config.headers.Authorization = `Bearer ${token}`;

	return config;
});

apiInstance.interceptors.response.use(
	(response: AxiosResponse) => response.data,
	(error: AxiosError) =>
		error.response && error.response.data && error.response.data.message
			? Promise.reject(new Error(error.response.data.message))
			: Promise.reject(error)
);
